// src/redux/scienceOfSelf/Scienceofselfapi.js
import { endpoints } from "../apiEndpoints/apiEndpoints";
import apiService from "../services/apiCore";

// ==================== ORIGINAL SCIENCE OF SELF APIs ====================

// ✅ Create Science of Self
export const createScienceOfSelfAPI = async (scienceData) => {
  try {
    const endpoint = endpoints.createScienceOfSelf;
    const response = await apiService.post(endpoint, scienceData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get All Science of Self List
export const getScienceOfSelfListAPI = async ({
  page = 1,
  limit = 10,
  search = ""
} = {}) => {
  try {
    const params = { page, limit, search };
    const response = await apiService.get(endpoints.getScienceOfSelfList, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Science of Self by ID
export const getScienceOfSelfByIdAPI = async (id) => {
  try {
    const endpoint = endpoints.getScienceOfSelfById.replace('{id}', id);
    const response = await apiService.get(endpoint);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Update Science of Self
export const updateScienceOfSelfAPI = async (science_id, scienceData) => {
  try {
    const endpoint = endpoints.updateScienceOfSelf.replace('{science_id}', science_id);
    const response = await apiService.put(endpoint, scienceData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Delete Science of Self
export const deleteScienceOfSelfAPI = async (science_id) => {
  try {
    const endpoint = endpoints.deleteScienceOfSelf.replace('{science_id}', science_id);
    const response = await apiService.delete(endpoint);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Archive/Unarchive Science of Self
export const archiveScienceOfSelfAPI = async (science_id, is_archive = true) => {
  try {
    const endpoint = endpoints.archiveScienceOfSelf.replace('{science_id}', science_id);
    const response = await apiService.put(endpoint, { is_archive });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ==================== SESSION MANAGEMENT APIs ====================

// ✅ Add Science of Self Session
export const addScienceOfSelfSessionAPI = async (sessionData) => {
  try {
    const endpoint = endpoints.addScienceOfSelfSession;
    const response = await apiService.post(endpoint, sessionData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Science of Self Sessions by Science ID
export const getScienceOfSelfSessionsAPI = async ({ science_id, page = 1, limit = 10, search = "" }) => {
  try {
    const endpoint = endpoints.getScienceOfSelfSessions.replace('{science_id}', science_id);
    const params = { page, limit, search };
    const response = await apiService.get(endpoint, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Enable/Disable Tool for Science of Self Session
export const enableDisableToolAPI = async (toolData) => {
  try {
    const endpoint = endpoints.enableDisableTool;
    const response = await apiService.post(endpoint, toolData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Enable/Disable Assignment for Science of Self Session
export const enableDisableAssignmentAPI = async (assignmentData) => {
  try {
    const endpoint = endpoints.enableDisableAssignment;
    const response = await apiService.post(endpoint, assignmentData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Enable/Disable Support Document for Science of Self Session
export const enableDisableSupportDocumentAPI = async (supportDocData) => {
  try {
    const endpoint = endpoints.enableDisableSupportDocument;
    const response = await apiService.post(endpoint, supportDocData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Science of Self Session Details
// GET /science-of-self/sessions/{science_of_self_session_id}/details
// Params:
//   - science_of_self_session_id (path)  : number (required)
//   - science_of_self_id         (query) : number (required)
export const getScienceOfSelfSessionDetailsAPI = async (
  science_of_self_session_id,
  science_of_self_id
) => {
  try {
    const endpoint = endpoints.getScienceOfSelfSessionDetails.replace(
      '{science_of_self_session_id}',
      science_of_self_session_id
    );
    const params = { science_of_self_id };
    const response = await apiService.get(endpoint, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Enable/Disable Science of Self Session
// POST /science-of-self/sessions/enable
// Body:
//   - science_of_self_id         : number  (required) — ID of the science of self
//   - science_of_self_session_id : number  (required) — ID of the session to enable/disable
//   - assign_status              : boolean (required) — true to enable, false to disable
//   - mark_completed             : boolean (optional) — directly mark the session as completed
//     without requiring tool, assignment, or supported document APIs
export const enableDisableScienceOfSelfSessionAPI = async ({
  science_of_self_id,
  science_of_self_session_id,
  assign_status,
  mark_completed = false,
}) => {
  try {
    const endpoint = endpoints.enableDisableScienceOfSelfSession;
    const response = await apiService.post(endpoint, {
      science_of_self_id,
      science_of_self_session_id,
      assign_status,
      mark_completed,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};